/** Dial codes with ISO2 for flag images (flagcdn) and emoji fallback. */
export const PHONE_COUNTRY_CODES = [
  { value: "+91", iso: "in", label: "India", flag: "🇮🇳" },
  { value: "+1", iso: "us", label: "United States", flag: "🇺🇸" },
  { value: "+44", iso: "gb", label: "United Kingdom", flag: "🇬🇧" },
  { value: "+971", iso: "ae", label: "United Arab Emirates", flag: "🇦🇪" },
  { value: "+65", iso: "sg", label: "Singapore", flag: "🇸🇬" },
  { value: "+61", iso: "au", label: "Australia", flag: "🇦🇺" },
  { value: "+81", iso: "jp", label: "Japan", flag: "🇯🇵" },
  { value: "+86", iso: "cn", label: "China", flag: "🇨🇳" },
  { value: "+49", iso: "de", label: "Germany", flag: "🇩🇪" },
  { value: "+33", iso: "fr", label: "France", flag: "🇫🇷" },
  { value: "+966", iso: "sa", label: "Saudi Arabia", flag: "🇸🇦" },
  { value: "+974", iso: "qa", label: "Qatar", flag: "🇶🇦" },
  { value: "+968", iso: "om", label: "Oman", flag: "🇴🇲" },
  { value: "+965", iso: "kw", label: "Kuwait", flag: "🇰🇼" },
  { value: "+973", iso: "bh", label: "Bahrain", flag: "🇧🇭" },
  { value: "+92", iso: "pk", label: "Pakistan", flag: "🇵🇰" },
  { value: "+880", iso: "bd", label: "Bangladesh", flag: "🇧🇩" },
  { value: "+94", iso: "lk", label: "Sri Lanka", flag: "🇱🇰" },
  { value: "+977", iso: "np", label: "Nepal", flag: "🇳🇵" },
  { value: "+60", iso: "my", label: "Malaysia", flag: "🇲🇾" },
  { value: "+66", iso: "th", label: "Thailand", flag: "🇹🇭" },
  { value: "+62", iso: "id", label: "Indonesia", flag: "🇮🇩" },
  { value: "+63", iso: "ph", label: "Philippines", flag: "🇵🇭" },
  { value: "+82", iso: "kr", label: "South Korea", flag: "🇰🇷" },
  { value: "+39", iso: "it", label: "Italy", flag: "🇮🇹" },
  { value: "+34", iso: "es", label: "Spain", flag: "🇪🇸" },
  { value: "+31", iso: "nl", label: "Netherlands", flag: "🇳🇱" },
  { value: "+41", iso: "ch", label: "Switzerland", flag: "🇨🇭" },
  { value: "+46", iso: "se", label: "Sweden", flag: "🇸🇪" },
  { value: "+7", iso: "ru", label: "Russia", flag: "🇷🇺" },
  { value: "+55", iso: "br", label: "Brazil", flag: "🇧🇷" },
  { value: "+27", iso: "za", label: "South Africa", flag: "🇿🇦" },
  { value: "+234", iso: "ng", label: "Nigeria", flag: "🇳🇬" },
  { value: "+254", iso: "ke", label: "Kenya", flag: "🇰🇪" },
  { value: "+20", iso: "eg", label: "Egypt", flag: "🇪🇬" },
  { value: "+90", iso: "tr", label: "Turkey", flag: "🇹🇷" },
  { value: "+64", iso: "nz", label: "New Zealand", flag: "🇳🇿" },
  { value: "+852", iso: "hk", label: "Hong Kong", flag: "🇭🇰" },
];

export function getPhoneCountryByCode(code) {
  const normalized = String(code || "").trim();
  return PHONE_COUNTRY_CODES.find((c) => c.value === normalized) || PHONE_COUNTRY_CODES[0];
}

export function phoneCountryFlagUrl(iso, width = 20) {
  return `https://flagcdn.com/w${width}/${String(iso || "in").toLowerCase()}.png`;
}
